import { render } from "./BGOutlineAlerts.vue?vue&type=template&id=a704b102&ts=true"
import script from "./BGOutlineAlerts.vue?vue&type=script&lang=ts"
export * from "./BGOutlineAlerts.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__